import { render, staticRenderFns } from "./SsPaginationNew.vue?vue&type=template&id=f9298e5e&scoped=true&"
import script from "./SsPaginationNew.vue?vue&type=script&lang=js&"
export * from "./SsPaginationNew.vue?vue&type=script&lang=js&"
import style0 from "./SsPaginationNew.vue?vue&type=style&index=0&id=f9298e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9298e5e",
  null
  
)

export default component.exports